import React, { useState } from 'react';
import styles from './HeaderRight.module.scss';
import { usePremium, useUser, useIsMobile } from '@/hooks';
import { HeaderUserMenu } from '../HeaderUserMenu/HeaderUserMenu';
import { LoginModal } from '@/modals/LoginModal/LoginModal';
import {
  Button,
  EButtonSize,
  EButtonHierarchy,
  EButtonStyle,
} from '@/components/common/Button/Button';
import { LottieAnimation } from '@/components/common/LottieAnimation/LottieAnimation';
import { LimitedTimeDiscountBanner } from '@/components/feedback/LimitedTimeDiscountBanner/LimitedTimeDiscountBanner';
import { ANALYTICS } from '@/constants/analytics/analytics';

export const HeaderRight: React.FC = () => {
  const user = useUser();
  const { isTabletOrSmaller } = useIsMobile();
  const [showLoginModal, setShowLoginModal] = useState(false);
  const [showLimitedTimeBanner, setShowLimitedTimeBanner] = useState(false);
  const premiumHook = usePremium();

  const openLogin = () => {
    setShowLoginModal(true);
  };

  const openPremium = () => {
    premiumHook
      .openPremium({ source: ANALYTICS.VALUES.HEADER_PREMIUM_CTA })
      .finally();
  };

  const handleBannerVisibilityChange = (visible: boolean) => {
    setShowLimitedTimeBanner(visible);
  };

  const handleBannerComplete = () => {
    setShowLimitedTimeBanner(false);
  };

  return (
    <div className={styles.headerRightContentWrapper}>
      {!user.isLogin() && (
        <Button
          dataAttribute={'headerLoginBtn'}
          hierarchy={EButtonHierarchy.primary}
          buttonStyle={EButtonStyle.tonal}
          size={EButtonSize.md}
          fillWidth={false}
          onClick={openLogin}
          text={'buttons.login'}
        />
      )}
      {user.isLogin() && <HeaderUserMenu />}
      {!isTabletOrSmaller && (
        <LimitedTimeDiscountBanner
          onComplete={handleBannerComplete}
          onVisibilityChange={handleBannerVisibilityChange}
        />
      )}
      {!user.isPremium() && !showLimitedTimeBanner && (
        <div onClick={openPremium} className={styles.premiumBtnWrapper}>
          <LottieAnimation height={40} animationName="go_unlimited" />
        </div>
      )}
      {showLoginModal && (
        <LoginModal
          onClose={() => setShowLoginModal(false)}
          source={ANALYTICS.VALUES.HEADER}
        />
      )}
    </div>
  );
};
